import { notification } from "antd";

export const openNotificationWithIcon = (type, message, description, key) => {
  notification[type]({
    message: <p>{message}</p>,
    description,
    key,
  });
};
